import React, { useState } from "react";

import styles from "./DetailsSection.scss";
import GroupData from "./GroupData";
import GoogleAd from "../../../../components/GoogleAd";
import { googleAds } from "appConfig";
import utilsStyles from "./../../../../styles/utils.scss";


const DetailsSection = ({ adDetails, category, adId, hrPageName, insertAfterSectionName, extraContent }: any) => {
  const [adLoaded, setAdLoaded] = useState(false);

  if (!adDetails) {
    return null;
  }

  return adDetails.map((groupData, index) => (
    <React.Fragment key={groupData.name}>
      {index === 2 && (
        <GoogleAd
          noTopMargin={true}
          className={adLoaded ? styles.adLoaded : ""}
          adLoadCallback={() => setAdLoaded(true)}
          config={{
            ...googleAds.detailPageMobile.box2,
            id: "googleAds.detailPageMobile.box2",
          }}
        />
      )}
      <GroupData
        sectionName={groupData.name}
        type={groupData.type}
        data={groupData.data}
        category={category}
        adId={adId}
        hrPageName={hrPageName}
      />
      {extraContent && insertAfterSectionName && groupData.name === insertAfterSectionName && extraContent}
    </React.Fragment>
  ));
};

export default DetailsSection;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/AdDetailsPageMobile/DetailsSection/index.tsx